import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-policyterms',
  templateUrl: './policyterms.component.html',
  styleUrls: ['./policyterms.component.scss']
})
export class PolicytermsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
